import {
  MarkdownRendererForNuclino,
  NuclinoMarkdownRendererProps,
} from "./MarkdownRendererForNuclino";

interface Props extends NuclinoMarkdownRendererProps {}

export function MarkdownRendererForOnboarding(props: Props) {
  return (
    <MarkdownRendererForNuclino
      {...props}
      isUseDefaultMargins={true}
      componentProps={{
        ...props.componentProps,
        contentWrapper: {
          sx: { fontSize: (th) => th.typography.pxToRem(16) },
        },
        p: {
          sx: { fontSize: (th) => th.typography.pxToRem(16) },
        },
      }}
    />
  );
}
